module.exports = __webpack_public_path__ + "static/media/test-drive.85deda79.svg";